/* ============
 * Locale
 * ============
 *
 * For a multi-language application,
 * specify the languages you want to use here.
 */

import en from './en'; // English
import ru from './ru'; // Russian

export default {
  en,
  ru,
};
